<script setup lang="ts">
// 클라이언트 사이드에서 세션 복원 확인
onMounted(async () => {
  const userStore = useUserStore()

  // 세션이 아직 초기화되지 않았다면 복원 시도
  if (!userStore.isSessionInitialized) {
    await userStore.getCurrentUser()
  }
})
</script>

<template>
  <v-app>
    <ClientDrawerRight />
    <AppBar />
    <v-main>
      <slot />
    </v-main>
    <Footer />

    <!-- 전역 다이얼로그 -->
    <GlobalDialog />
  </v-app>
</template>

<style scoped>
/* AppBar 고정에 따른 전역 스타일 조정 */
:deep(.v-main) {
  /* @media (max-width: 959px) {
    padding-left: 5px !important;
    padding-right: 5px !important;
  } */
}
</style>
